import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import RenderRoutes from "./routes";
import { Spin } from "antd";
import { useEffect } from "react";
import { clearUserLogin, setUserLogin } from "./redux/slices/user-slice";
import { clearUserFromCookies } from "./utils/useStorage";
import { Helmet } from "react-helmet";

function App() {
  const { loading, title } = useSelector((state) => state.global);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedUserLogin = localStorage.getItem("userInfo");

    if (storedUserLogin) {
      const userLoginData = JSON.parse(storedUserLogin);

      // Kiểm tra xem userLoginData có chứa thuộc tính expires không
      if (userLoginData.expires) {
        const expirationDate = userLoginData.expires;

        // Kiểm tra thời gian hết hạn
        if (expirationDate && expirationDate < new Date().getTime()) {
          // Xóa dữ liệu và thiết lập trạng thái chưa xác thực
          dispatch(clearUserLogin());
          localStorage.removeItem("userInfo");
          clearUserFromCookies();
        } else {
          dispatch(setUserLogin(userLoginData));
        }
      }
    }
  }, [dispatch]);

  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Spin spinning={loading} size="large">
        <RenderRoutes />
      </Spin>
    </div>
  );
}

export default App;
